module.exports = __webpack_public_path__ + "img/text5.c0c75e1f.png";